import { reportEventBus } from "./ReportEvents";

// Deterministic BOE ELI permalinks / act lookups for the norms the report
// text can mention. Ported verbatim from the design source's `normUrl()` —
// same keys, same URLs. Extend here as new norms show up in real content.
const BOE_ACT = (id: string) => `https://www.boe.es/buscar/act.php?id=${id}`;
const BOE_ELI = (path: string) => `https://www.boe.es/eli/es/${path}`;

const NORM_URL_MAP: Record<string, string> = {
  LH: BOE_ACT("BOE-A-1946-2453"),
  LIVA: BOE_ELI("l/1992/12/28/37"),
  "LEY 37/1992": BOE_ELI("l/1992/12/28/37"),
  TRLITPAJD: BOE_ELI("rdlg/1993/09/24/1"),
  "RDLEG 1/1993": BOE_ELI("rdlg/1993/09/24/1"),
  TRLHL: BOE_ELI("rdlg/2004/03/05/2"),
  "RDLEG 2/2004": BOE_ELI("rdlg/2004/03/05/2"),
  TRLCI: BOE_ELI("rdlg/2004/03/05/1"),
  "RDLEG 1/2004": BOE_ELI("rdlg/2004/03/05/1"),
  LGT: BOE_ELI("l/2003/12/17/58"),
  "LEY 58/2003": BOE_ELI("l/2003/12/17/58"),
  LIS: BOE_ELI("l/2014/11/27/27"),
  "LEY 27/2014": BOE_ELI("l/2014/11/27/27"),
  TRLIRNR: BOE_ELI("rdlg/2004/03/05/5"),
  "RDLEG 5/2004": BOE_ELI("rdlg/2004/03/05/5"),
  "ORDEN ECO/805/2003": BOE_ACT("BOE-A-2003-7253"),
  "RDLEG 7/2015": BOE_ELI("rdlg/2015/10/30/7"),
  "RD 1492/2011": BOE_ELI("rd/2011/10/24/1492"),
  "LEY 10/2010": BOE_ELI("l/2010/04/28/10"),
  "RD 304/2014": BOE_ELI("rd/2014/05/05/304"),
  "LEY 13/2015": BOE_ELI("l/2015/06/24/13"),
  "LEY 11/2021": BOE_ELI("l/2021/07/09/11"),
  "LEY 24/2001": BOE_ELI("l/2001/12/27/24"),
  "RD 417/2006": BOE_ELI("rd/2006/04/07/417"),
  "RD 856/2008": BOE_ELI("rd/2008/05/16/856"),
};

export const BOE_SEARCH_URL = "https://www.boe.es/buscar/legislacion_ava.php";

export function normUrl(token: string): string | null {
  const key = String(token).trim().replace(/\s+/g, " ").toUpperCase();
  return NORM_URL_MAP[key] || null;
}

// A token is treated as a recognized legal norm — clickable, opens this
// modal — rather than just bolded, if it resolves to a known BOE URL or
// matches the shape of a norm reference (design source: `isNorma()`).
export function isNorma(token: string): boolean {
  const s = String(token).trim();
  if (normUrl(s)) return true;
  if (/^(Ley|Real\s+Decreto|RD|RDL|RDLeg|Orden)\b/i.test(s)) return true;
  return /^(LH|RH|LIVA|TRLITPAJD|TRLHL|TRLCI|LIS|TRLIRNR|LGT|LOTUP|TRLOTUP)$/.test(s);
}

export const openNorma = (label: string, url: string | null, text?: string) =>
  reportEventBus.emit("REPORT_OPEN_NORMA", { label, url, text });
